export enum RoleEnum {
  Admin = 1,
  Specialist = 6,
  TeamLead = 15
}
